/**
 * 成语填字接龙小游戏 Vue 3 Island 挂载入口
 * 支持挂载至首页 Hero 中的 #hero-chengyu-game-island 或独立页面的 #chengyu-game-island
 */
import { createApp } from 'vue'
import App from './App.vue'
import type { LevelItem } from './lib/types'

const heroMountEl = document.getElementById('hero-chengyu-game-island')
const standaloneMountEl = document.getElementById('chengyu-game-island')
const mountEl = heroMountEl || standaloneMountEl

if (mountEl) {
    const isHero = !!heroMountEl
    const rawData = mountEl.getAttribute('data-level-data')
    const rawTotal = mountEl.getAttribute('data-total-levels')
    const totalLevels = rawTotal ? parseInt(rawTotal, 10) : 100

    let initialLevel: LevelItem | null = null
    if (rawData) {
        try {
            initialLevel = JSON.parse(rawData) as LevelItem
        } catch (e) {
            console.error('[chengyu-game] 解析 data-level-data 失败:', e)
        }
    }

    const app = createApp(App, {
        initialLevel,
        totalLevels,
        isHero,
    })

    if (import.meta.env.DEV) {
        app.config.performance = true
    }

    app.config.errorHandler = (err, _instance, info) => {
        console.error('[chengyu-game] Vue Error:', err)
        console.error('[chengyu-game] Error Info:', info)
    }

    app.mount(mountEl)
}

